import React, { useState, useEffect } from "react";
import { IconContext } from "react-icons";
import { BsSearch } from "react-icons/bs";

import { full_name } from "../../libs/coin_list";
import coins from "../../libs/coins/coins.json";
import ModalDialog from "../Modal";

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

type Props = {
  onChange: Function;
  balance?: number;
  selectedCoin?: string;
};

export default function SelectCoin(props: Props) {
  const { selectedCoin } = props;
  const coin_list = coins;
  const [open, setOpen] = React.useState(false);
  const [select, setSelect] = useState(
    coin_list.find((c) => c.address === props.selectedCoin)
  );
  const [search, setSearch] = useState("");
  const [coinList, setCoinList] = useState(coin_list);

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleSelect = (item: any) => {
    setSelect(item);
    props.onChange(item);
    handleClose();
  };

  const handleSearch = (item: any) => {
    setSearch(item.target.value);
    if (item.target.value !== "") {
      const list = coin_list.filter((i) => {
        return i.name.search(item.target.value);
      });
      setCoinList(list);
    } else {
      setCoinList(coin_list);
    }
  };

  useEffect(() => {
    const selectedItem = coin_list.find((c) => c.address === selectedCoin);
    setSelect(selectedItem);
  }, [coin_list, selectedCoin]);

  return (
    <div>
      <div className="flex flex-col items-center">
        <button
          className="px-2 py-1 border-none rounded-full bg-primary-200 bg-opacity-100 flex items-center gap-2"
          onClick={handleClickOpen}
        >
          <img alt="Coin" width={30} src={select?.logoURI} />
          <span className="text-[15px] whitespace-nowrap font-semibold text-white">
            {select?.name}
          </span>
          {/* <span className="text-xs">{full_name(select.address)}</span> */}
        </button>
        <div className="text-base text-left mt-3 text-white">
          Balance:
          <span style={{ color: "#2196f3", marginLeft: "11px" }}>
            {props.balance ? Number(props.balance) : "0.00"}
          </span>
        </div>
      </div>

      <ModalDialog open={open} handleClose={handleClose} title="">
        <div className="flex flex-col py-4">
          <div className="relative flex items-center mb-4 px-6 gap-2">
            <IconContext.Provider value={{ color: "white", size: "1.5em" }}>
              <BsSearch />
            </IconContext.Provider>
            ;
            <input
              value={search}
              onChange={handleSearch}
              placeholder="Search Coin"
              className="text-left w-full bg-transparent outline-none text-xl text-white text-opacity-70"
            />
          </div>
          <div className="flex gap-2 pb-6 border-b mx-6  border-opacity-30 border-white">
            {coinList.map((item, index) => {
              return (
                <button
                  className="flex text-white gap-2 border-white rounded-full border px-4 py-1 justify-center items-center"
                  key={index}
                  onClick={() => handleSelect(item)}
                >
                  <img width={24} alt={item.name} src={item.logoURI} />
                  <span>{item.name.slice(0, 4)}</span>
                </button>
              );
            })}
          </div>
          <div className="flex flex-col px-6 ">
            {coinList.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  handleSelect(item);
                }}
                className="flex items-center p-2 gap-3 rounded-md cursor-pointer hover:bg-white hover:bg-opacity-25"
              >
                <div>
                  <img width={40} alt={item.name} src={item.logoURI} />
                </div>
                <div className="flex flex-col text-white justify-center">
                  <span>{item.name}</span>
                  <span>{full_name(item.address)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ModalDialog>

      {/* <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          <FormControl sx={{ m: 1, width: '400px', paddingRight: '200px' }} variant="standard">
            <Input
              id="standard-adornment-amount"
              value={search}
              onChange={handleSearch}
              placeholder="Search by token"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </FormControl>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1} sx={{ marginBottom: 1 }}>
            {coinList.map((item, index) => {
              return (
                <Grid key={index} item sx={{ margin: '2px' }} onClick={() => handleSelect(item)}>
                  <Button size={'small'} variant="outlined">
                    <Avatar sx={{ width: 24, height: 24, marginRight: 1 }} alt={item.name} src={item.icon} />
                    {item.name}
                  </Button>
                </Grid>
              )
            })}
          </Grid>

          <Divider />

          <List component="nav">
            {coinList.map((item, index) => (
              <ListItemButton
                key={index}
                onClick={() => {
                  handleSelect(item)
                }}
              >
                <ListItemIcon>
                  <Avatar alt={item.name} src={item.icon} />
                </ListItemIcon>
                <ListItemText primary={item.name} secondary={full_name(item.address)} />
              </ListItemButton>
            ))}
          </List>
        </DialogContent>
      </BootstrapDialog> */}
    </div>
  );
}
